module.exports = __webpack_public_path__ + "static/22_API-719a3796e96203c808eb817107c3ab65.png";